import { isEmbedded } from '@/core/utils/EmbeddedPage'

// Mixin for pages that need to send their title to the parent window when embedded in an iframe.
// Override `embeddedPageTitle` computed property in the component if custom logic is needed.
export default {
  computed: {
    embeddedPageTitle() {
      return this.title || null
    }
  },
  mounted() {
    this.sendEmbeddedPageTitle()
  },
  watch: {
    embeddedPageTitle() {
      this.sendEmbeddedPageTitle()
    },
    $route() {
      this.sendEmbeddedPageTitle()
    }
  },
  methods: {
    sendEmbeddedPageTitle() {
      if (isEmbedded() && this.embeddedPageTitle) {
        window.parent.postMessage(
          { type: 'title', title: this.embeddedPageTitle },
          '*'
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/iframeTitleMixin.js